var _defs, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelxonLogolighttheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 155.4 50.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        mask: url(#mask);\n      }\n\n      .cls-2 {\n        fill: #000b55;\n      }\n\n      .cls-3 {\n        mask: url(#mask-2);\n      }\n\n      .cls-4 {\n        mask: url(#mask-3);\n      }\n\n      .cls-5 {\n        mask: url(#mask-1);\n      }\n\n      .cls-6 {\n        fill: #fa9fad;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #6bd4f2;\n      }\n\n      .cls-9 {\n        fill: #fed929;\n      }\n\n      .cls-10 {\n        fill: #0098fd;\n      }\n    "), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 19.94,
    y: 25.94,
    width: 21.41,
    height: 24.36,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_60_539",
    "data-name": "mask0 60 539"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M19.94,25.94h21.41v24.36h-21.41v-24.36Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: -0.03,
    y: 0,
    width: 21.05,
    height: 24.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask1_60_539",
    "data-name": "mask1 60 539"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-.03,0h21.05v24.31H-.03V0Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 22.11,
    y: 5.39,
    width: 19.24,
    height: 18.93,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask2_60_539",
    "data-name": "mask2 60 539"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M22.11,5.39h19.24v18.93h-19.24V5.39Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: -0.03,
    y: 25.94,
    width: 18.89,
    height: 18.93,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask3_60_539",
    "data-name": "mask3 60 539"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-.03,25.94h18.89v18.93H-.03v-18.93Z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.3,26.18c.91-.17,1.7.44,1.88,1.34-.26,3.97.38,8.45.01,12.36-.07.8-.24,1.1-.91,1.53l-17.16,8.62c-1.41.67-2.4-.03-2.54-1.53-.26-2.97-.26-8.83,0-11.8.11-1.23.5-1.42,1.48-1.96l17.22-8.57h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M18.86,0c.79-.09,1.69.52,1.74,1.35-.25,4.02.38,8.54.02,12.5-.07.73-.32,1-.91,1.39L2.29,24.06c-1.27.39-2.29-.39-2.29-1.72,0-3.05.09-6.14.16-9.19.03-1.41-.49-3.52.9-4.28L18.86,0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.45,5.47c.88-.1,1.68.58,1.75,1.48v15.68c-.09,1.16-1.15,1.84-2.25,1.4l-15.44-7.77c-1.08-.57-1.31-2.03-.23-2.74l16.17-8.05h0Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M18.27,36.6L2.26,44.73c-.85.36-2.04-.12-2.11-1.11l.08-16.6c.41-.79,1.28-1.09,2.11-.69l15.36,7.7c.96.51,1.25,1.7.57,2.57h0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.71,13.6v22.63h-2.36v-10.44h-14.16v10.44h-2.39V13.6h2.39v10.09h14.16v-10.09h2.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.41,28.44h-14.22c.13,1.77.81,3.2,2.04,4.28,1.23,1.09,2.78,1.63,4.66,1.63,1.05,0,2.02-.19,2.91-.57.88-.38,1.65-.93,2.3-1.66l1.29,1.49c-.76.91-1.7,1.6-2.83,2.07-1.13.47-2.38.71-3.74.71-1.75,0-3.29-.37-4.64-1.12-1.35-.74-2.4-1.77-3.15-3.08-.76-1.32-1.13-2.81-1.13-4.46s.36-3.15,1.08-4.46c.72-1.32,1.71-2.34,2.97-3.08,1.26-.73,2.68-1.1,4.25-1.1s2.99.37,4.23,1.1c1.25.73,2.23,1.75,2.94,3.06.71,1.3,1.07,2.8,1.07,4.48l-.03.71ZM81.2,21.07c-1.64,0-3.01.52-4.12,1.57-1.11,1.04-1.74,2.4-1.88,4.08h12.06c-.15-1.68-.78-3.04-1.89-4.08-1.11-1.05-2.5-1.57-4.16-1.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.13,12.24h2.29v23.99h-2.29V12.24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.65,36.23l-5.39-7.12-5.43,7.12h-2.59l6.73-8.73-6.41-8.27h2.59l5.11,6.66,5.1-6.66h2.52l-6.4,8.27,6.79,8.73h-2.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.42,36.39c-1.63,0-3.11-.37-4.43-1.12-1.31-.74-2.35-1.77-3.1-3.08-.76-1.32-1.13-2.81-1.13-4.46s.38-3.15,1.13-4.46c.76-1.32,1.79-2.34,3.1-3.08,1.32-.73,2.79-1.1,4.43-1.1s3.11.37,4.43,1.1c1.32.73,2.35,1.76,3.09,3.08.74,1.31,1.12,2.8,1.12,4.46s-.37,3.14-1.12,4.46c-.74,1.31-1.77,2.34-3.09,3.08-1.31.74-2.79,1.12-4.43,1.12ZM126.42,34.36c1.21,0,2.29-.27,3.25-.82.96-.55,1.7-1.34,2.24-2.35.54-1.01.81-2.17.81-3.46s-.27-2.45-.81-3.46c-.54-1.01-1.28-1.8-2.24-2.35-.96-.55-2.04-.83-3.25-.83s-2.29.28-3.24.83c-.96.55-1.71,1.34-2.26,2.35-.55,1.01-.83,2.16-.83,3.46s.28,2.44.83,3.46c.55,1.01,1.31,1.8,2.26,2.35.96.55,2.04.82,3.24.82Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.41,19.1c2.13,0,3.83.62,5.1,1.86,1.26,1.24,1.89,3.05,1.89,5.42v9.86h-2.3v-9.63c0-1.77-.44-3.11-1.33-4.04-.89-.93-2.15-1.39-3.79-1.39-1.83,0-3.28.55-4.35,1.64-1.07,1.09-1.6,2.59-1.6,4.5v8.92h-2.29v-17h2.2v3.14c.62-1.04,1.49-1.84,2.6-2.41,1.11-.57,2.4-.86,3.86-.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelxonLogolighttheme);
export default __webpack_public_path__ + "static/media/helxonLogolighttheme.69bb9a6b658ca537ca6c23698bf6d343.svg";
export { ForwardRef as ReactComponent };